import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type TuffexVariantAttributeType = {
    id: Uuid;
    workspaceId: Uuid;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
    createdBy: Uuid;
    updatedBy: Uuid;
    displayName: string;
};

export type PostTuffexVariantAttributeType = {
    createdBy: Uuid;
    updatedBy: Uuid;
    displayName: string;
};

export const tuffexVariantAttributeTypeValidator: zod.ZodType<TuffexVariantAttributeType> = zod.object({
    id: uuidZodValidator,
    workspaceId: uuidZodValidator,
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    updatedBy: uuidZodValidator,
    displayName: zod.string(),
});

export const postTuffexVariantAttributeTypeValidator: zod.ZodType<PostTuffexVariantAttributeType> = zod.object({
    createdBy: uuidZodValidator,
    updatedBy: uuidZodValidator,
    displayName: zod.string(),
});
